import React, { useState, useRef } from 'react';
import Dropdown from '../../../../common/dropdown';
import { copyToClipboard } from '../../../../../common/clipboard-helper';
import Notification from '../../../../common/notification';

const App = ({ publishData }) => {
  const [ notificationObject, setNotificationObject ] = useState(null);
  const [ systemName, setSystemName ] = useState(publishData.system_names[0]);
  const [ language, setLanguage ] = useState(publishData.languages[0]);
  const textAreaRef = useRef(null);

  const onChangeSystemName = (selectedItem) => {
    setSystemName(selectedItem);
  };
  const onChangeLanguage = (selectedItem) => {
    setLanguage(selectedItem);
  };

  const copyCode = (event) => {
    textAreaRef.current.select();
    copyToClipboard({
      text: textAreaRef.current.value,
      goodCallback: () => {
        setNotificationObject(
          { message: 'Code successfully copied to clipboard!', success: true }
        );
      }
    });
  };

  return (
    <div className="tool-code">
      <div className="dropdowns-section">
        <Dropdown
          value={ systemName }
          options={ publishData.system_names }
          onChange={ onChangeSystemName }
        />
        <Dropdown
          value={ language }
          options={ publishData.languages }
          onChange={ onChangeLanguage }
        />
      </div>
      <textarea
        id={ `${systemName.value}${language.value}` }
        ref={ textAreaRef }
        className="widget-code_code"
        value={ publishData.codes[systemName.value][language.value] }
        onChange={ () => {
        } }
      />
      <div className="copy-code-wrapper">
        <a className="button copy-code" onClick={ copyCode }>Copy Code</a>
      </div>
      <Notification
        messageObject={ notificationObject }
        onDeactivate={ () => { setNotificationObject(null); } }
        interval={ 10 }
      />
    </div>
  );
};

export default App;
